import { hasAllPurposesConsent } from "@escapio/shared/tracker/ConsentObserver";
import { hasTracking } from "@escapio/shared/state/client-settings";

customElements.define(
	"esc-bing-loader",
	class extends HTMLElement {
		async connectedCallback() {
			if (!hasTracking) return;
			await hasAllPurposesConsent;
			this.load();
		}

		load() {
			/* eslint-disable no-undef,indent */
			(function (w, d, t, r, u) {
				var f, n, i;
				(w[u] = w[u] || []),
					(f = function () {
						var o = { ti: "4026031" };
						(o.q = w[u]), (w[u] = new UET(o)), w[u].push("pageLoad");
					}),
					(n = d.createElement(t)),
					(n.src = r),
					(n.async = 1),
					(n.onload = n.onreadystatechange =
						function () {
							var s = this.readyState;
							(s && s !== "loaded" && s !== "complete") ||
								(f(), (n.onload = n.onreadystatechange = null));
						}),
					(i = d.getElementsByTagName(t)[0]),
					i.parentNode.insertBefore(n, i);
			})(window, document, "script", "//bat.bing.com/bat.js", "uetq");
			window.uetq = window.uetq || [];
		}
	},
);
